import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

class Footer extends Component {
 
  componentWillMount() {}

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  shouldComponentUpdate(nextProps, nextState) {}

  componentWillUpdate(nextProps, nextState) {}

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {}

  render() {
    return (
      <footer className="footer text-center ">
        <Typography varient="body4" align="center">
          {"Developed by  "}
          <Link
            color="inherit"
            href="https://www.linkedin.com/in/kuldeep-mewara/"
          >
            Kuldeep Mewara
          </Link>
          {" ❤️ "}
          {new Date().getFullYear()}
          {"."}
        </Typography>
      </footer>
    );
  }
}


export default Footer;
